module["exports"] = [
  "دیزل",
  "الکتریکی",
  "بنزین",
  "هیبرید"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/vehicle/fuel.js
// module id = 2917
// module chunks = 1609